export default (url) => {
  if (!url) {
    return window.magicApp?.toast('未填写URL');
  }
  if (!window.openApp) {
    return window.magicApp?.toast('no window.openApp');
  }
  window.openApp(url);
};
